<template>
  <div>
    <!--    model-->
    <div class="overlay" v-show="show"></div>
    <div class="modal" v-show="show">
      <div class="model-title">
        <div class="model-title-left">邀请对方填写合同</div>
        <div class="model-close" @click="closeEvent">x</div>
      </div>
      <div class="model-content">
        <!--        窗口内容-->
        <div style="width: 70%; float: left; ">
          <p class="m--margin-top-25 "><span style="font-weight: bold">链接地址</span> ( 对方填写后，可在<a target="_blank"
                                                                                                style="color: #E61717"
                                                                                                href="https://web.1dq.com/#/fill"
                                                                                                class="text-blue">草稿箱</a>中查看
            )</p>
          <div class="form-group  ">
            <input type="text" v-model="link" class="form-control m-input " placeholder="链接地址">
            <input type="button" class="btn m-btn" @click="doCopy" value="复制">
          </div>
        </div>
        <div style="width: 30%; float: right; text-align: right">
          <img :src="'https://api-v2.1dq.com/v2/QrCode?logo=1dq&url=' + encodeURIComponent(link)" width="100"
               height="100">
        </div>

        <!--        内容结束-->
      </div>
    </div>
    <!--    -->
  </div>
</template>

<script>
export default {
  name: "qr-link",
  props: ["link", "show"],
  methods: {
    closeEvent() {
      this.$emit("close")
    },
    doCopy() {
      this.$copyText(this.link).then(e => {
        this.api.alert('复制成功')
        console.log(e)
      }, e => {
        this.api.alert('复制失败，请手动复制')
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.m-input {
  width: 70%;
  float: left;
  background: #FFFFFF !important;
  border: 1px solid rgb(206, 212, 218) !important;
  border-top-right-radius: unset !important;
  border-bottom-right-radius: unset !important;
  border-right: none !important
}

.m-btn {
  width: 30%;
  float: right;
  padding: .55rem 1rem;
  background-color: #e54d42 !important;
  border-top-left-radius: unset !important;
  border-bottom-left-radius: unset !important
}

.modal {
  max-width: 500px;
  margin-left: -250px;
  height: 230px;
  margin-top: -125px;
}

.model-content {
  padding: 35px 30px;
}

@media screen and (max-width: 600px) {
  .modal {
    width: 100%;
    margin-left: 0;
    left: 0;
  }

  .model-content {
    padding: 30px 15px;
  }
}

</style>